import React, { useState } from "react";
import { Actions as userActions } from "../../core/redux/ducks/user";
import { useFormFields } from "../../libs/hooksLib";
import { useAppContext } from "../../libs/contextLib";
import { SignupModal } from "./SignupModal";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  makeStyles,
  Card,
  CardContent,
  TextField,
  Grid,
  Typography,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { ReactComponent as SignUpImg } from "../../assets/imgs/Signup_lady.svg";
import { ReactComponent as SignUpBackground } from "../../assets/imgs/Signup_mtn.svg";
import styled from "styled-components";

import GoogleSocialAuth from "../../components/GoogleSocialAuth";
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const Login = () => {
  const { userHasAuthenticated } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: "",
  });
  const classes = useStyles();
  const userData = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const getToken = (param) => userActions.getToken(dispatch, param);
  const getTokenGoogle = (accessToken) =>
    userActions.getTokenGoogle(dispatch, accessToken);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const credentials = {
        email: event.target.email.value,
        password: event.target.password.value,
      };
      const isAllowed = await getToken(credentials);
      if (isAllowed) userHasAuthenticated(true);
    } catch (e) {
      setIsLoading(false);
    }
  };

  const handleGoogleAuth = async (data) => {
    try {
      const isAllowed = await getTokenGoogle(data["accessToken"]);
      if (isAllowed) userHasAuthenticated(true);
    } catch (e) {}
  };

  return (
    <div className={classes.root}>
      <Circle top="-50px" right="-50px" color="#00b0f0" size="250px" />
      <Circle bottom="5px" left="20px" color="#00b0f0" size="150px" />
      <Circle bottom="-50px" right="25%" color="#ccc" size="200px" />
      <img src={"images/logo_color.svg"} className={classes.image} alt="logo" />
      <Card className={classes.card}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={5}
        >
          <Grid item md={6} lg={6} className={classes.imgContainer}>
            <SignUpBackground className={classes.imgBackground} />
            <SignUpImg className={classes.imgLogin} />
          </Grid>
          <Grid item md={6} lg={6} className={classes.formContainer}>
            <Box p="5% 20%" height={1}>
              <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
              >
                <Grid item className={classes.header}>
                  <Typography className={classes.blueText}>
                    Login and...
                  </Typography>
                  <Typography className={classes.headerText}>
                    Research the smart way!
                  </Typography>
                </Grid>
                <Grid item className={classes.errorContainer}>
                  {userData.error && (
                    <Alert severity="error">{userData.error}</Alert>
                  )}
                </Grid>
              </Grid>
              <form onSubmit={handleSubmit}>
                <CardContent className={classes.form}>
                  <TextField
                    id="email"
                    label="email"
                    variant="outlined"
                    value={fields.email}
                    className={classes.textField}
                    onChange={handleFieldChange}
                    fullWidth
                  />
                  <TextField
                    id="password"
                    label="Password"
                    type="password"
                    variant="outlined"
                    value={fields.password}
                    className={classes.textField}
                    onChange={handleFieldChange}
                    fullWidth
                  />
                  <Box mt={5} mb={5} width={1} height={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      // disabled={!validateForm()}
                      fullWidth
                    >
                      {isLoading ? (
                        <img
                          src="images/loader.gif"
                          height="30"
                          alt="loading"
                        />
                      ) : (
                        <span>Login</span>
                      )}
                    </Button>
                    <Grid
                      container
                      direction="row"
                      spacing={2}
                      className={classes.signUpButtons}
                    >
                      <Grid item md={6}>
                        <Button
                          color="primary"
                          onClick={() => setModalOpen(true)}
                          fullWidth
                          variant="outlined"
                        >
                          Signup
                        </Button>
                      </Grid>

                      <Grid item md={6}>
                        <GoogleSocialAuth
                          clientId={GOOGLE_CLIENT_ID}
                          render={(renderProps) => {
                            return (
                              <Button
                                color="primary"
                                onClick={renderProps.onClick}
                                fullWidth
                                variant="outlined"
                                className={classes.googleButton}
                              >
                                <img
                                  src="images/google.png"
                                  alt="google"
                                  className={classes.googleIcon}
                                />
                                <Typography>Google</Typography>
                              </Button>
                            );
                          }}
                          onSuccess={handleGoogleAuth}
                          onFailure={(data) => console.log(data)}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
              </form>
            </Box>
          </Grid>

          <SignupModal
            modalOpen={modalOpen}
            closeModal={() => setModalOpen(false)}
          />
        </Grid>
      </Card>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    margin: 0,
    width: "100%",
  },
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    backgroundColor: "#fff",
    borderRadius: "5px",
    // width: "100%",
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  image: {
    width: "150px",
    position: "absolute",
    bottom: "1.5%",
    right: "4%",
  },
  card: {
    boxShadow: "1px 2px 5px 0px rgba(0, 0, 0, 0.2)",
    width: "93%",
    height: "86%",
    borderRadius: "10px",
  },
  errorContainer: {
    height: "80px",
    margin: "6%",
  },
  header: {
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  blueText: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: "12pt",
  },
  headerText: {
    fontSize: "19pt",
  },
  button: {
    width: 1,
  },

  formContainer: {
    position: "relative",
    width: "100%",
    height: "101vh;",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    padding: "0",
  },
  imgContainer: {
    position: "relative",
    width: "100%",
    height: "101vh;",
  },
  imgLogin: {
    position: "absolute",
    width: "79%",
    height: "58%",
    left: "110px",
  },
  imgBackground: {
    position: "absolute",
    backgroundColor: "#e6f7fe",
    width: "100%",
    height: "130%",
    top: "20px",
  },
  signUpButtons: {
    marginTop: "20px",
  },
  googleButton: {
    height: "100%",
    textTransform: "none",
  },
  googleIcon: {
    width: "15px",
    margin: "0 10px",
  },
}));

export const Circle = styled.div`
  position: absolute;
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  bottom: ${(props) => props.bottom};
  right: ${(props) => props.right};
  border-radius: 100px;
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.1);
  background-color: ${(props) => props.color};
  z-index: -1;
`;
